// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HeaderService } from '../../../header.service';
import { D3eService } from '../../../../services/d3e-service';
import { withLoading } from '../../../../shared/misc';
import { SelectedOrgMethod } from '../../../../shared/selectedOrg';

@UntilDestroy({checkProperties: true})
@Component({
    selector: 'app-endpoints-locked',
    templateUrl: './endpoints-locked.component.html',
    styleUrls: ['./endpoints-locked.component.scss'],
    standalone: false
})
export class EndpointsLockedComponent {
  lockedEndpoints$: Observable<number>;
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  lockedEndpointsLink = '/endpoints';
  endpointsTarget = {endpoints_target: 'status'};

  constructor(private headerService: HeaderService,
              private d3eService: D3eService) {
    this.lockedEndpoints$ = this.headerService.orgSelectedChanged
      .pipe(
        switchMap((selectedOrgId) => {
            const selectedOrg = SelectedOrgMethod.getSelectedOrg(selectedOrgId);
            return this.d3eService.getEndpointsLocked(selectedOrg).pipe(
                withLoading(isLoading => this.loading$.next(isLoading))
            );
        }),
        map(response => response.endpointsLocked),
        catchError(error => {
          // TODO: pass error to child? so it can show error appropriately?
          //  Also, show a snack bar with error?
          return throwError(error);
        }),
        untilDestroyed(this)
      );
  }

}
